<nav class="nav flex-column sidenav" *transloco="let t">
  <div *ngIf="primaryNavOptions$ | async as options" class="mb-0">
    @if (options.get(PrimaryNavKey.Dashboard); as option) {
      <nav-option [option]="option">
        <ng-container icon>
          <i class="modus-icons notranslate">dashboard</i>
        </ng-container>
      </nav-option>
    }

    <ng-container *ngIf="options.get(PrimaryNavKey.Accounts) as option">
      <nav-option [option]="option">
        <ng-container icon>
          <svg
            height="1.5rem"
            width="1.5rem"
            [attr.aria-label]="t('ams.ams.fleetAccountsAltText')"
          >
            <use
              xlink:href="/assets/img/fleet-accounts.svg#fleetAccounts"
            ></use>
          </svg>
        </ng-container>
      </nav-option>
    </ng-container>

    <ng-container *ngIf="options.get(PrimaryNavKey.Assets) as option">
      <nav-option [option]="option" data-tour-poi="assetsNav">
        <ng-container icon>
          <i class="modus-icons notranslate">people_group</i>
        </ng-container>
      </nav-option>
    </ng-container>

    <ng-container *ngIf="options.get(PrimaryNavKey.Cfs) as option">
      <nav-option
        [option]="option"
        (click)="openSideNav()"
        data-tour-poi="cfsNav"
      >
        <ng-container icon>
          <svg height="1.5rem" width="1.5rem" aria-hidden="true">
            <use xlink:href="/assets/img/configure_fleet.svg#cfs"></use>
          </svg>
        </ng-container>
        <ng-container subnav>
          @if (sideNavOpen()) {
            <app-secondary-nav
              [key]="SecondaryNavKey.Cfs"
              [active]="determineActiveRoute(option.routerLink)"
            ></app-secondary-nav>
          }
        </ng-container>
      </nav-option>
    </ng-container>

    <ng-container *ngIf="options.get(PrimaryNavKey.ManageAccount) as option">
      <nav-option [option]="option" (click)="openSideNav()">
        <ng-container icon>
          <i class="modus-icons notranslate">manage_accounts</i>
        </ng-container>
        <ng-container subnav>
          @if (sideNavOpen()) {
            <app-secondary-nav
              [key]="SecondaryNavKey.ManageAccount"
              [active]="determineActiveRoute(option.routerLink)"
            ></app-secondary-nav>
          }
        </ng-container>
      </nav-option>
    </ng-container>

    <ng-container *ngIf="options.get(PrimaryNavKey.Weather) as option">
      <nav-option [option]="option">
        <ng-container icon>
          <i class="modus-icons notranslate">weather_alerts</i>
        </ng-container>
      </nav-option>
    </ng-container>

    <ng-container
      *ngIf="options.get(PrimaryNavKey.Reporting) as option"
      class="mt-auto"
    >
      <nav-option [option]="option" (click)="openSideNav()">
        <ng-container icon>
          <mop-icon [name]="'reports'"></mop-icon>
        </ng-container>
        <ng-container subnav>
          @if (sideNavOpen()) {
            <app-secondary-nav
              [key]="SecondaryNavKey.Reporting"
              [active]="determineActiveRoute(option.routerLink)"
            ></app-secondary-nav>
          }
        </ng-container>
      </nav-option>
    </ng-container>

    <ng-container
      *ngIf="options.get(PrimaryNavKey.Diagnostics) as option"
      class="mt-auto"
    >
      <nav-option [option]="option" (click)="openSideNav()">
        <ng-container icon>
          <i class="modus-icons notranslate">tree_structure</i>
        </ng-container>
        <ng-container subnav>
          @if (sideNavOpen()) {
            <app-secondary-nav
              [key]="SecondaryNavKey.Diagnostics"
              [active]="determineActiveRoute(option.routerLink)"
            ></app-secondary-nav>
          }
        </ng-container>
      </nav-option>
    </ng-container>
  </div>
</nav>
<ng-content></ng-content>
